export default __webpack_public_path__ + "static/media/Gizmosity.e2f47ba4.pdf";